export const CHANNEL_STATUS_LABELS = {
  connected: '🟢 Conectado',
  pending: '🟡 Aguardando leitura do QR code',
  disconnected: '🔴 Desconectado',
  error: '🔴 Desconectado'
};

export const OFFLINE_CHANNEL_STATUSES = ['disconnected', 'error'];

export function isChannelOffline(channel) {
  return OFFLINE_CHANNEL_STATUSES.includes(channel.status);
}

export function needsAttention(channel) {
  return isChannelOffline(channel) || channel.status === 'pending';
}

export function channelOptionLabel(channel) {
  const name = channel.connectorName ? `${channel.name} (${channel.connectorName})` : channel.name;
  const status = CHANNEL_STATUS_LABELS[channel.status];
  return status ? `${name} · ${status}` : name;
}

export function channelOption(channel) {
  return { value: channel.id, label: channelOptionLabel(channel) };
}
